// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"unavailable-module--wrapper--3Yn_D","button":"unavailable-module--button--uXwQ4"};